import React from "react";

const AdmissionsMockup = React.lazy(() => import("./AdmissionsMockup"));
const FeesMockup = React.lazy(() => import("./FeesMockup"));
const AttendanceMockup = React.lazy(() => import("./AttendanceMockup"));
const LmsMockup = React.lazy(() => import("./LmsMockup"));
const ExamsMockup = React.lazy(() => import("./ExamsMockup"));
const ResultsMockup = React.lazy(() => import("./ResultsMockup"));
const TimetableMockup = React.lazy(() => import("./TimetableMockup"));
const HrMockup = React.lazy(() => import("./HrMockup"));
const PayrollMockup = React.lazy(() => import("./PayrollMockup"));
const PlacementMockup = React.lazy(() => import("./PlacementMockup"));
const ObeMockup = React.lazy(() => import("./ObeMockup"));
const CertificatesMockup = React.lazy(() => import("./CertificatesMockup"));
const FeedbackMockup = React.lazy(() => import("./FeedbackMockup"));
const DocumentsMockup = React.lazy(() => import("./DocumentsMockup"));
const RegisterMockup = React.lazy(() => import("./RegisterMockup"));
const MentorMockup = React.lazy(() => import("./MentorMockup"));
const WebsiteMockup = React.lazy(() => import("./WebsiteMockup"));
const LibraryMockup = React.lazy(() => import("./LibraryMockup"));
const VisitorMockup = React.lazy(() => import("./VisitorMockup"));
const WhatsappMockup = React.lazy(() => import("./WhatsappMockup"));
const ReportsMockup = React.lazy(() => import("./ReportsMockup"));

export const mockupComponents = {
  "admissions-form": AdmissionsMockup,
  "fees-dashboard": FeesMockup,
  "attendance-calendar": AttendanceMockup,
  "lms-courses": LmsMockup,
  "exams-schedule": ExamsMockup,
  "results-card": ResultsMockup,
  "timetable-grid": TimetableMockup,
  "hr-directory": HrMockup,
  "payroll-slip": PayrollMockup,
  "placement-stats": PlacementMockup,
  "obe-report": ObeMockup,
  "certificate-preview": CertificatesMockup,
  "feedback-form": FeedbackMockup,
  "document-manager": DocumentsMockup,
  "register-table": RegisterMockup,
  "mentor-pairing": MentorMockup,
  "cms-editor": WebsiteMockup,
  "library-catalog": LibraryMockup,
  "visitor-checkin": VisitorMockup,
  "whatsapp-composer": WhatsappMockup,
  "analytics-dashboard": ReportsMockup,
};
